import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import Grid from "../../../components/Grid";
import { ShowBtn } from "@/components/Show";
import { CreateLoaderInput } from "../../../components/Loaders";
import { DeleteBtn } from "@/components/Delete";
// import { TypeTableProps } from "@/App/Plans/Table";
// import { TableDataProps } from "@/pages/Route";
import {
  deleteCircuitRoute,
  updateToggleActiveRoute,
} from "@/Api/circuit_routes";
import { UpdateBtn } from "../Update";
import { InternalAxiosRequestConfig } from "axios";
import { usePermissions } from "@/hooks/usePermissions";
import { If } from "@/components/If";
import { ComponentSwitchToggleStatus } from "@/App/Courses/ActivedOrDisabled";

export const TableData = ({ dataApi, updateFront }: any) => {
  const { hasPermission } = usePermissions();
  return (
    <>
      <Table className="bg-zinc-50 rounded dark:bg-[#2c2c2c]">
        <TableHeader>
          <TableRow>
            <TableHead>Titulo</TableHead>
            <TableHead>Data Inicial</TableHead>
            <TableHead className="text-center">Ativo</TableHead>
            <TableHead className="text-center">Ações</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {dataApi?.data?.map((item, index) => {
            return (
              <TableRow key={index}>
                <TableCell className="truncate max-w-80">
                  {item?.title}
                </TableCell>
                <TableCell>
                  {new Date(item?.starts.replace(/-/g, "/")).toLocaleDateString(
                    "pt-BR",
                    {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    }
                  )}
                </TableCell>
                <TableCell>
                  <ComponentSwitchToggleStatus
                    defaultChecked={item?.is_active}
                    params={{
                      func: updateToggleActiveRoute,
                      funcParams: item?.id,
                    }}
                    updateFront={() =>
                      updateFront((prev) => {
                        return {
                          ...prev,
                          data: prev?.data?.map((values) => {
                            if (values?.id === item?.id)
                              return {
                                ...values,
                                is_active: !values?.is_active,
                              };
                            return values;
                          }),
                        };
                      })
                    }
                  />
                </TableCell>
                <TableCell className="flex justify-center">
                  <div className="flex gap-3 w-full justify-center">
                    <If condition={hasPermission("delete-circuit-route")}>
                      <DeleteBtn
                        params={{
                          func: deleteCircuitRoute,
                          funcParams:
                            item?.id_circuit_plan?.replace("plans/", "") || "",
                        }}
                        updateFront={() =>
                          updateFront((prev) => ({
                            ...prev,
                            data: [
                              ...prev?.data?.filter(
                                (data) =>
                                  data?.id_circuit_plan !==
                                  item?.id_circuit_plan
                              ),
                            ],
                          }))
                        }
                        referenceLabel={item?.title}
                      />
                    </If>

                    <If condition={hasPermission("edit-circuit-route")}>
                      <UpdateBtn
                        updateFront={updateFront}
                        planId={item?.id_circuit_plan?.replace("plans/", "")}
                      />
                    </If>
                    <If condition={hasPermission("show-circuit-route")}>
                      <ShowBtn
                        labels={{ title: "Visualizar Rota" }}
                        params={{
                          func: () =>
                            new Promise((resolve) => {
                              setTimeout(() => {
                                resolve({
                                  data: {
                                    response: {
                                      title: item?.title,
                                      starts: item?.starts,
                                      optimization: item?.optimization,
                                      routes: item?.routes,
                                      depot: item?.depot,
                                      created_at: item?.created_at,
                                      updated_at: item?.updated_at,
                                      is_active: item?.is_active,
                                    },
                                  },
                                  status: 200,
                                  statusText: "OK",
                                  headers: {},
                                  config: {} as InternalAxiosRequestConfig,
                                  ok: true,
                                });
                              }, 1000);
                            }),
                          funcParams: item?.id_circuit_plan?.replace(
                            "plans/",
                            ""
                          ),
                        }}
                        render={(responseApi) => (
                          <div className="w-full h-auto">
                            <div className="flex flex-col gap-3 overflow-y-auto h-[300px]">
                              {responseApi?.title && (
                                <Grid.Item name="Título" flex={0}>
                                  {responseApi.title}
                                </Grid.Item>
                              )}
                              {responseApi?.starts && (
                                <Grid.Item name="Data de Início" flex={0}>
                                  {new Date(
                                    responseApi.starts
                                  ).toLocaleDateString("pt-BR", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                  })}
                                </Grid.Item>
                              )}
                              {responseApi?.routes && (
                                <Grid.Item name="Número de Paradas" flex={0}>
                                  {responseApi.routes.length}
                                </Grid.Item>
                              )}
                              {responseApi?.routes?.map((route, index) => (
                                <div
                                  key={index}
                                  className="flex flex-col gap-2 border p-2 rounded"
                                >
                                  <Grid.Item
                                    name={`Parada ${index + 1}`}
                                    flex={0}
                                  >
                                    <a
                                      href={route?.webAppLink}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text-blue-500 font-bold underline"
                                    >
                                      Ver Rota
                                    </a>
                                  </Grid.Item>
                                  {route?.address?.addressLineOne && (
                                    <Grid.Item name="Endereço" flex={0}>
                                      {route.address.addressLineOne}
                                    </Grid.Item>
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                        loader={<CreateLoaderInput lines={5} />}
                      />
                    </If>
                  </div>
                </TableCell>
              </TableRow>
            );
          })}
          {(!dataApi?.data || dataApi?.data?.length < 1) && (
            <TableRow>
              <TableCell colSpan={7}>Nada foi encontrado.</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </>
  );
};
